export type Tool = {
  label: string;
  link: string;
};

export const tools: Tool[] = [
  {
    label: 'VSCode',
    link: 'https://azure.microsoft.com/ja-jp/products/visual-studio-code/',
  },
  {
    label: 'XCode',
    link: 'https://developer.apple.com/jp/xcode/',
  },
  {
    label: 'Android Studio',
    link: 'https://developer.android.com/studio',
  },
  {
    label: 'Chrome',
    link: 'https://www.google.com/intl/ja_jp/chrome/',
  },
  {
    label: 'zsh',
    link: '',
  },
  {
    label: 'WSL',
    link: 'https://docs.microsoft.com/ja-jp/windows/wsl/',
  },
  {
    label: 'Figma',
    link: 'https://www.figma.com/',
  },
  {
    label: 'Sketch',
    link: 'https://www.sketch.com/',
  },
  {
    label: 'AdobeXD',
    link: 'https://www.adobe.com/jp/products/xd.html',
  },
  {
    label: 'Flinto',
    link: 'https://www.flinto.com/',
  },
  {
    label: 'Slack',
    link: 'https://slack.com/intl/ja-jp/',
  },
  {
    label: 'Notion',
    link: 'https://www.notion.so/ja-jp/product',
  },
];
